"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpShareAssessmentModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var orderBy_1 = __importDefault(require("lodash/orderBy"));
var api_1 = require("../../../api");
var constants_1 = require("../../../api/constants");
var __1 = require("..");
var Auth_1 = require("../../Auth");
var DpTeachersList_1 = __importDefault(require("./TeachersList/DpTeachersList"));
var DpShareAssessmentModal_styled_1 = require("./DpShareAssessmentModal.styled");
var limit = 100;
var DpShareAssessmentModal = function (_a) {
    var show = _a.show, closeModal = _a.closeModal, assessmentTemplate = _a.assessmentTemplate, submitHandler = _a.submitHandler;
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)([]), allTeachers = _c[0], setallTeachers = _c[1];
    var _d = (0, react_1.useState)([]), schools = _d[0], setSchools = _d[1];
    var _e = (0, react_1.useState)(false), allTeachersSelected = _e[0], setallTeachersSelected = _e[1];
    var _f = (0, react_1.useState)([]), selectedTeachers = _f[0], setSelectedteachers = _f[1];
    var _g = (0, react_1.useState)(false), showShareSubmitButton = _g[0], setShareSubmitButton = _g[1];
    var _h = (0, react_1.useState)(false), allSchoolsSelected = _h[0], setAllSchoolsSelected = _h[1];
    var _j = (0, react_1.useState)(0), skip = _j[0], setSkip = _j[1];
    var _k = (0, react_1.useState)(false), allteachersfetched = _k[0], setAllteachersfetched = _k[1];
    var _l = (0, react_1.useState)([]), schoolIdArr = _l[0], setSchoolIdArr = _l[1];
    var _m = (0, react_1.useState)(0), totalTeacherRecords = _m[0], setTotalTeacherRecords = _m[1];
    var teacherListRef = (0, react_1.useRef)(null);
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var _o = (0, react_1.useContext)(api_1.ServiceContext), userService = _o.userService, assessmentTemplateService = _o.assessmentTemplateService;
    var user = (0, react_1.useContext)(Auth_1.AuthContext).user;
    var publish = (0, react_1.useContext)(__1.AlertManagerContext).publish;
    var toast = (0, react_1.useContext)(__1.AtomicAlertManagerContext).toast;
    var fetchSchools = (0, react_1.useCallback)(function () {
        // TODO: add ripl schools after pivot
        return new Promise(function (resolve) { return resolve(user.schools); });
    }, [user]);
    var selectTeacher = function (allChecked, teachers) {
        var teachersSelection = teachers.filter(function (_a) {
            var selected = _a.selected;
            return selected;
        });
        setallTeachersSelected(allChecked);
        setallTeachers(teachers);
        setSelectedteachers(teachersSelection);
        setShareSubmitButton(!!teachers.filter(function (_a) {
            var selected = _a.selected, disabled = _a.disabled;
            return selected && !disabled;
        }).length);
    };
    var fetchTeachers = function (schoolIds) {
        userService
            .findDistrictStaff({ districtId: user.districtId, schoolIds: schoolIds, role: [constants_1.UserRole.Teacher] }, 0, limit)
            .then(function (_a) {
            var staffList = _a.staffList, totalRecords = _a.totalRecords;
            setTotalTeacherRecords(totalRecords);
            var teachersOption = [];
            (0, orderBy_1.default)(staffList, ['lastName']).map(function (staff) {
                var _a, _b, _c, _d, _e;
                teachersOption.push({
                    teacher: {
                        id: (_a = staff.teacher) === null || _a === void 0 ? void 0 : _a.id,
                        firstName: staff.firstName,
                        lastName: staff.lastName,
                    },
                    selected: !!((_b = assessmentTemplate.sharedUserIds) === null || _b === void 0 ? void 0 : _b.includes((_c = staff.teacher) === null || _c === void 0 ? void 0 : _c.id)),
                    disabled: !!((_d = assessmentTemplate.sharedUserIds) === null || _d === void 0 ? void 0 : _d.includes((_e = staff.teacher) === null || _e === void 0 ? void 0 : _e.id)),
                });
                return staff;
            });
            setSkip(1);
            setallTeachers(teachersOption);
            setSelectedteachers([]);
            setallTeachersSelected(false);
            setShareSubmitButton(false);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.teacherList'),
                },
            });
        })
            .finally(function () {
            setInitialized(true);
        });
    };
    var submitShareAssessmentHandler = function () {
        return assessmentTemplateService
            .share(assessmentTemplate.id, selectedTeachers.filter(function (_a) {
            var disabled = _a.disabled;
            return !disabled;
        }).map(function (_a) {
            var teacher = _a.teacher;
            return teacher.id;
        }), assessmentTemplate.curriculum)
            .then(function () {
            publish(__1.AlertOptions.info({
                alert: {
                    message: t('shareAssessmentModal.shareSuccess', {
                        teacherCount: selectedTeachers.length,
                        teachers: selectedTeachers.length > 1 ? 'teachers' : 'teacher',
                    }),
                    actionLabel: t('shareAssessmentModal.ok'),
                },
            }));
            if (submitHandler) {
                submitHandler();
            }
            closeModal();
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.shareAssessment'),
                },
            });
        });
    };
    var initialize = function () {
        fetchSchools()
            .then(function (schoolsList) {
            if (schoolsList.length) {
                var schoolOptions = schoolsList.map(function (school) { return ({
                    id: school.id,
                    title: school.name,
                    selected: true,
                }); });
                setSchoolIdArr(schoolsList.map(function (_a) {
                    var id = _a.id;
                    return id;
                }));
                schoolOptions.unshift({
                    id: 'allSchools',
                    title: 'All',
                    selected: true,
                });
                setSchools(schoolOptions);
                setAllSchoolsSelected(true);
                fetchTeachers(schoolsList.map(function (_a) {
                    var id = _a.id;
                    return id;
                }));
                setAllteachersfetched(false);
            }
            else {
                setInitialized(true);
                setallTeachers([]);
            }
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.schoolList'),
                },
            });
            setInitialized(true);
        });
    };
    var filterSchools = function (selected) {
        var temp = schools.map(function (option) { return (__assign(__assign({}, option), { selected: selected })); });
        temp[0].indeterminate = false;
        setSchools(temp);
        setAllSchoolsSelected(selected);
    };
    var selectSchools = function (selectedOptions) { return __awaiter(void 0, void 0, void 0, function () {
        var schoolIds, temp, temp;
        return __generator(this, function (_a) {
            schoolIds = [];
            if (selectedOptions.length) {
                if (schools.length - selectedOptions.length === 1) {
                    // if only one option is deselected
                    if (selectedOptions[0].id !== 'allSchools') {
                        if (allSchoolsSelected) {
                            // if deselected option is "ALL"
                            filterSchools(false);
                        }
                        else {
                            // if all schools selected one by one then make ALL as selected
                            filterSchools(true);
                            schoolIds = selectedOptions
                                .filter(function (option) { return option.selected && option.id !== 'allSchools'; })
                                .map(function (_a) {
                                var id = _a.id;
                                return id;
                            });
                        }
                    }
                    else if (selectedOptions[0].id === 'allSchools' && !allSchoolsSelected) {
                        // select ALL option (after only 1 option is unchecked)
                        filterSchools(true);
                        schoolIds = schools.filter(function (option) { return option.id !== 'allSchools'; }).map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                    }
                    else {
                        // if deselected option is from school list, make ALL as in indeterminate
                        schools[0].indeterminate = true;
                        schools[0].selected = false;
                        temp = schools.map(function (school) { return (__assign({}, school)); });
                        schoolIds = selectedOptions
                            .filter(function (option) { return option.selected && option.id !== 'allSchools'; })
                            .map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        setAllSchoolsSelected(false);
                        setSchools(temp);
                    }
                }
                else if (selectedOptions[0].id === 'allSchools') {
                    // select ALL option
                    filterSchools(true);
                    schoolIds = schools.filter(function (option) { return option.id !== 'allSchools'; }).map(function (_a) {
                        var id = _a.id;
                        return id;
                    });
                }
                else {
                    schoolIds = selectedOptions
                        .filter(function (option) { return option.selected && option.id !== 'allSchools'; })
                        .map(function (_a) {
                        var id = _a.id;
                        return id;
                    });
                }
            }
            if (schoolIds.length) {
                fetchTeachers(schoolIds);
                setSchoolIdArr(schoolIds);
            }
            else {
                setallTeachers([]);
                setSelectedteachers([]);
                setallTeachersSelected(false);
                setShareSubmitButton(false);
                setInitialized(true);
                if (schools.length && schools[0].indeterminate) {
                    schools[0].indeterminate = false;
                    temp = schools.map(function (school) { return (__assign({}, school)); });
                    setSchools(temp);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var onScroll = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var staffList, teachersOption_1, sortedTeachers, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 1 &&
                        !allteachersfetched)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, userService.findDistrictStaff({ districtId: user.districtId, schoolIds: schoolIdArr, role: [constants_1.UserRole.Teacher] }, skip, limit)];
                case 2:
                    staffList = (_a.sent()).staffList;
                    if (staffList.length !== limit) {
                        setAllteachersfetched(true);
                    }
                    teachersOption_1 = [];
                    staffList.map(function (staff) {
                        var _a, _b, _c, _d;
                        teachersOption_1.push({
                            teacher: {
                                id: (_a = staff.teacher) === null || _a === void 0 ? void 0 : _a.id,
                                firstName: staff.firstName,
                                lastName: staff.lastName,
                            },
                            selected: !!((_b = assessmentTemplate.sharedUserIds) === null || _b === void 0 ? void 0 : _b.includes((_c = staff.teacher) === null || _c === void 0 ? void 0 : _c.id)),
                            disabled: !!((_d = assessmentTemplate.sharedUserIds) === null || _d === void 0 ? void 0 : _d.includes(staff.teacher.id)),
                        });
                        return staff;
                    });
                    sortedTeachers = (0, orderBy_1.default)(__spreadArray(__spreadArray([], allTeachers, true), teachersOption_1, true), function (item) { var _a; return (_a = item.teacher.lastName) === null || _a === void 0 ? void 0 : _a.toUpperCase(); });
                    setallTeachers(sortedTeachers);
                    setSkip(skip + 1);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast({
                        alertVariant: 'error',
                        content: {
                            title: t('errorMessages.oopsErr'),
                            message: t('errorMessages.teacherList'),
                        },
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onAllTeacherSelectHandler = function (closeAllTeacherModal) {
        setInitialized(false);
        var fetchArr = [];
        closeAllTeacherModal();
        var fetchLength = Math.ceil(totalTeacherRecords / limit);
        for (var i = skip; i < fetchLength; i++) {
            fetchArr.push(userService.findDistrictStaff({ districtId: user.districtId, schoolIds: schoolIdArr, role: [constants_1.UserRole.Teacher] }, i, limit));
        }
        Promise.all(fetchArr)
            .then(function (resultList) {
            var tempteachers = [];
            resultList.map(function (i) {
                tempteachers = __spreadArray(__spreadArray([], tempteachers, true), i.staffList, true);
                return i;
            });
            var initialTeachersList = allTeachers.map(function (teacher) { return (__assign(__assign({}, teacher), { selected: true })); });
            tempteachers = tempteachers.map(function (staff) {
                var _a, _b, _c;
                return ({
                    teacher: {
                        id: ((_a = staff.teacher) === null || _a === void 0 ? void 0 : _a.id) || staff.id,
                        firstName: staff.firstName,
                        lastName: staff.lastName,
                    },
                    selected: true,
                    disabled: !!((_b = assessmentTemplate === null || assessmentTemplate === void 0 ? void 0 : assessmentTemplate.sharedUserIds) === null || _b === void 0 ? void 0 : _b.includes((_c = staff.teacher) === null || _c === void 0 ? void 0 : _c.id)),
                });
            });
            var sortedTeachers = (0, orderBy_1.default)(__spreadArray(__spreadArray([], initialTeachersList, true), tempteachers, true), function (item) { var _a; return (_a = item.teacher.lastName) === null || _a === void 0 ? void 0 : _a.toUpperCase(); });
            setallTeachers(sortedTeachers);
            setSelectedteachers(sortedTeachers);
            setInitialized(true);
            setAllteachersfetched(true);
            setShareSubmitButton(!!sortedTeachers.filter(function (_a) {
                var selected = _a.selected, disabled = _a.disabled;
                return selected && !disabled;
            }).length);
            setallTeachersSelected(true);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.teacherList'),
                },
            });
            setInitialized(true);
        });
    };
    (0, api_1.useMount)(function () {
        initialize();
    });
    return ((0, jsx_runtime_1.jsxs)(DpShareAssessmentModal_styled_1.StyledShareAssessmentModal, { show: show, onHide: closeModal, size: "lg", "aria-labelledby": "share-assessment-modal-title", children: [(0, jsx_runtime_1.jsx)(__1.DpModal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "title", children: [(0, jsx_runtime_1.jsx)("p", { id: "share-assessment-modal-title", children: t('shareAssessmentModal.shareAssessmentHeading') }), (0, jsx_runtime_1.jsx)("div", { className: "assessment-title", children: (0, jsx_runtime_1.jsx)("h1", { className: "h3", children: assessmentTemplate.title }) })] }) }), (0, jsx_runtime_1.jsx)(__1.DpModal.Body, { children: initialized ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "filters", children: (0, jsx_runtime_1.jsx)(__1.DpFilterDropdown, { classes: "filter", options: schools, selectHandler: selectSchools, multipleSelect: true, placeholder: t('shareAssessmentModal.schoolPlaceHolder'), id: "school-filter", visibleLabel: true }) }), (0, jsx_runtime_1.jsx)("div", { className: "teacher-list-content", ref: teacherListRef, onScroll: function (e) { return onScroll(e); }, children: (0, jsx_runtime_1.jsx)(DpTeachersList_1.default, { teachers: allTeachers, allTeachersSelected: allTeachersSelected, selectHandler: selectTeacher, onAllTeacherSelectHandler: onAllTeacherSelectHandler, totalRecords: totalTeacherRecords }) })] })) : ((0, jsx_runtime_1.jsx)(__1.Spinner, { className: "spinner" })) }), allTeachers.length ? ((0, jsx_runtime_1.jsx)(__1.DpModal.Footer, { children: (0, jsx_runtime_1.jsx)("div", { className: "actions", children: (0, jsx_runtime_1.jsx)(__1.DpLoadingWrapper, { onClick: submitShareAssessmentHandler, className: "submit-button", disabled: !showShareSubmitButton, "data-testid": "shareAssessmentButton", children: t('shareAssessmentModal.shareAssessmentButton') }) }) })) : null] }));
};
exports.DpShareAssessmentModal = DpShareAssessmentModal;
exports.default = exports.DpShareAssessmentModal;
